/**
 * rest 请求配置
 */
import { Message } from 'element-ui'
import ajax from '../common/ajax'
import Api from './index.d'

// 设置错误提示信息
ajax.setTipFn((tips: string) => {
  Message.error(tips)
})

const rest: Api = {
  Auth: {
    getAuthInfo: ajax.query('/auth'), // 应用授权
  },
}

export default rest
